// Updated CreateAbha.js with step persistence using localStorage
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import CountUp from "react-countup";

import MobileVerify from "../Mobile-verify/mobile-verify";
import MobileOtp from "../Mobile-otp/mobile-otp";
import Patient from "../Patient/patient";
import ConfirmDetail from "../Confirm-detail/confirm-details";
import AdharNumber from "../Adhar-number/adhar-number";
import AdhaOtp from "../Adhar-otp/adhar-otp";
import AbhaAddress from "../Abha-address/abha-address";
import AbhaCard from "../Abha-card/abha-card";
import AadharCard from "../aadhar-card/aadhar-card";
import MobileVerifyOtp from "../Mobile-verify-otp/mobile-verify-otp";

import lab from "../../assets/image/lab.png";
import about from "../../assets/image/about_nha_pg_logo.png";
import benefits from "../../assets/image/benefits.png";
import benefits2 from "../../assets/image/benefits2.png";
import benefits3 from "../../assets/image/benefits3.png";
import benefits4 from "../../assets/image/benefits4.png";
import benefits5 from "../../assets/image/benefits5.png";
import benefits6 from "../../assets/image/benefits6.png";
import googleplay from "../../assets/image/google-play.png";
import appstore from "../../assets/image/app-stor.png";
import { setAbhaLoader } from "../../redux/slices/abhaSlice";
import { useSelector } from "react-redux";
import MobileVerification from "../Adhar-otp/mobile-verification";
import { current } from "@reduxjs/toolkit";
import LoginMobileOTP from "../Mobile-verify/mobile-verify";
import LoginMobileOTPSend from "../Mobile-verify/mobile-verify";
import LoginMobileOtpVerify from "../Mobile-otp/mobile-otp";
import PatientList from "../Patient/patient";
import ConfirmPatientDetail from "../Confirm-detail/confirm-details";
import SendAdharOTP from "../Adhar-number/adhar-number";
import VerifyAdhaOtp from "../Adhar-otp/adhar-otp";
import MobileVerificationOTPSend from "../Adhar-otp/mobile-verification";
import MobileVerificationOTPVerify from "../Mobile-verify-otp/mobile-verify-otp";
import AbhaSuggestions from "../Abha-address/abha-address";
import PerferredAbhaOptions from "../Adhar-otp/PerferredAbhaOptions";
import MobileUpdateOTPSend from "../change-mobile";
import MobileVerificationOTPVerifyToUpdateContact from "../change-mobile/verification-screen";

const CreatAbha = ({ onNavigate }) => {
  const [sendOtpFunction, setSendOtpFunction] = useState(() => () => {});
  const [mobileOTPSent, setMobileOTPSent] = useState(false);
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [currentStep, setCurrentStep] = useState("LoginMobileOTPSend");
  const [isVerifiedotp, setIsVerifiedOtp] = useState(false);
  const [isPatient, setPatient] = useState(false);
  const [isconfirm, setIsconfirm] = useState(false);
  const [isAdharNumber, setAdharNumber] = useState(false);
  const [isAdharOtp, setAdharOtp] = useState(false);
  const [mobileVerificationOTPSent, setMobileVerificationOTPSent] =
    useState(false);
  const [isAdhaaddress, setAdhaaddress] = useState(false);
  const [isVerifiedMobileOTP, setMobileverifyOtp] = useState(false);
  const handleClick = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const { formRef, userData } = useOutletContext();

  const loader = useSelector((state) => state.user.loading);

  // console.log("isVerified", isAdharNumber);

  const globalCurrentStepp = useSelector(
    (state) => state.user.globalCurrentStep
  );

  const stepOrder = [
    "LoginMobileOTPSend",
    "LoginMobileOtpVerify",
    "PatientList",
    "ConfirmPatientDetail",
    "SendAdharOTP",
    "VerifyAdhaOtp",
    "MobileVerificationOTPSend",
    "MobileVerificationOTPVerify",
    "AbhaSuggestions",
    "AbhaCard"
  ];

  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      setCurrentStep("ConfirmPatientDetail");
    }
  }, [userData]);

  const handleBack = () => {
    const currentIndex = stepOrder.indexOf(currentStep);
    if (currentIndex > 0) {
      const prevStep = stepOrder[currentIndex - 1];
      setCurrentStep(prevStep);
    }
  };
  useEffect(() => {
    if (globalCurrentStepp) {
      setCurrentStep(globalCurrentStepp);
    }
  }, [globalCurrentStepp]);
  // const handleBack = () => {
  //   console.log("object");
  //   if (isAdhaaddress) setAdhaaddress(false);
  //   else if (isVerifiedMobileOTP) setMobileverifyOtp(false);
  //   else if (isAdharOtp) setAdharOtp(false);
  //   else if (isAdharNumber) setAdharNumber(false);
  //   else if (isconfirm) setIsconfirm(false);
  //   else if (isPatient) setPatient(false);
  //   else if (isVerifiedotp) setIsVerifiedOtp(false);
  //   else if (isMobileVerified) setIsMobileVerified(false);
  // };

  return (
    <>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "all"
          }}
        >
          {" "}
        </div>
      )}
      {currentStep === "LoginMobileOTPSend" && (
        <div ref={formRef}>
          <LoginMobileOTPSend
            setIsMobileVerified1={setIsMobileVerified}
            setMobileOTPSent={setMobileOTPSent}
            setIsVerifiedOtp={setIsVerifiedOtp}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {currentStep === "LoginMobileOtpVerify" && (
        <div ref={formRef}>
          <LoginMobileOtpVerify
            setIsVerifiedOtp={setIsVerifiedOtp}
            setMobileOTPSent={setMobileOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {currentStep === "PatientList" && (
        <div ref={formRef}>
          <PatientList
            isVerifiedotp={isVerifiedotp}
            setPatient={setPatient}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "ConfirmPatientDetail" && (
        <div ref={formRef}>
          <ConfirmPatientDetail
            userData={userData}
            isPatient={isPatient}
            setIsconfirm={setIsconfirm}
            handleBack={handleBack}
            setPatient={setPatient}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {(currentStep === "SendAdharOTP" ||
        currentStep === "AlreadyAbhaNumber") && (
        <div ref={formRef}>
          <SendAdharOTP
            isconfirm={isconfirm}
            setAdharNumber={setAdharNumber}
            setPatient1={setPatient}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {currentStep === "VerifyAdhaOtp" && (
        <div ref={formRef}>
          <VerifyAdhaOtp
            isAdharNumber={isAdharNumber}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setIsConfirm1={setIsconfirm}
            setSendOtpFunction={setSendOtpFunction}
            sendOtpFunction={sendOtpFunction}
            setMobileverifyOtp={setMobileverifyOtp}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "MobileVerificationOTPSend" && (
        <div ref={formRef}>
          <MobileVerificationOTPSend
            setMobileverifyOtp={setMobileverifyOtp}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "changeMobile" && (
        <div ref={formRef}>
          <MobileUpdateOTPSend
            setMobileverifyOtp={setMobileverifyOtp}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "MobileVerificationOTPVerify" && (
        <div ref={formRef}>
          <MobileVerificationOTPVerify
            isAdharOtp={isAdharOtp}
            setMobileverifyOtp={setMobileverifyOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setIsconfirm={setIsconfirm}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "MobileVerificationOTPVerifyToUpdateContact" && (
        <div ref={formRef}>
          <MobileVerificationOTPVerifyToUpdateContact
            isAdharOtp={isAdharOtp}
            setMobileverifyOtp={setMobileverifyOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setIsconfirm={setIsconfirm}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "PerferredAbhaOptions" && (
        <div ref={formRef}>
          <PerferredAbhaOptions setCurrentStep={setCurrentStep} />
        </div>
      )}
      {currentStep === "AbhaSuggestions" && (
        <div ref={formRef}>
          <AbhaSuggestions
            isVerifiedMobileOTP={isVerifiedMobileOTP}
            setAdhaaddress={setAdhaaddress}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "AbhaCard" && (
        <div ref={formRef}>
          <AbhaCard
            isAdhaaddress={isAdhaaddress}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {/* ######################################################## */}
      {/* {!mobileOTPSent && !isMobileVerified && (
        <div ref={formRef}>
          <MobileOtp
            setIsVerifiedOtp={setIsVerifiedOtp}
            setMobileOTPSent={setMobileOTPSent}
          />
        </div>
      )}
      {mobileOTPSent && (
        <div ref={formRef}>
          <MobileVerify
            setIsMobileVerified1={setIsMobileVerified}
            setMobileOTPSent={setMobileOTPSent}
            setIsVerifiedOtp={setIsVerifiedOtp}
          />
        </div>
      )}

      {isVerifiedotp && (
        <div ref={formRef}>
          <Patient isVerifiedotp={isVerifiedotp} setPatient={setPatient} />
        </div>
      )}
      {isPatient && !isconfirm && (
        <div ref={formRef}>
          <ConfirmDetail
            isPatient={isPatient}
            setIsconfirm={setIsconfirm}
            handleBack={handleBack}
            setPatient={setPatient}
          />
        </div>
      )}
      {isconfirm && !isAdharNumber && (
        <div ref={formRef}>
          <AdharNumber
            isconfirm={isconfirm}
            setAdharNumber={setAdharNumber}
            setPatient1={setPatient}
          />
        </div>
      )}
      {isAdharNumber && !isAdharOtp && (
        <div ref={formRef}>
          <AdhaOtp
            isAdharNumber={isAdharNumber}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setIsConfirm1={setIsconfirm}
            setSendOtpFunction={setSendOtpFunction}
            sendOtpFunction={sendOtpFunction}
            setMobileverifyOtp={setMobileverifyOtp}
          />
        </div>
      )}
      {isAdharOtp && (
        <div ref={formRef}>
          <MobileVerification
            setMobileverifyOtp={setMobileverifyOtp}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
          />
        </div>
      )}
      {mobileVerificationOTPSent && (
        <div ref={formRef}>
          <MobileVerifyOtp
            isAdharOtp={isAdharOtp}
            setMobileverifyOtp={setMobileverifyOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setIsconfirm={setIsconfirm}
          />
        </div>
      )}
      {isVerifiedMobileOTP && !isAdhaaddress && (
        <div ref={formRef}>
          <AbhaAddress
            isVerifiedMobileOTP={isVerifiedMobileOTP}
            setAdhaaddress={setAdhaaddress}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
          />
        </div>
      )}
      {isAdhaaddress ? (
        <div ref={formRef}>
          <AbhaCard isAdhaaddress={isAdhaaddress} />
        </div>
      ) : (
        ""
      )} */}

      {/* ##################################### */}

      {/* {step === "mobile-verify" && (
        <div ref={formRef}>
          <MobileVerify setIsVerified={() => goToNextStep("mobile-otp")} />
        </div>
      )}
      {step === "mobile-otp" && (
        <div ref={formRef}>
          <MobileOtp setIsVerifiedOtp={() => goToNextStep("patient")} />
        </div>
      )}
      {step === "patient" && (
        <div ref={formRef}>
          <Patient setPatient={() => goToNextStep("confirm-detail")} />
        </div>
      )}
      {step === "confirm-detail" && (
        <div ref={formRef}>
          <ConfirmDetail setIsconfirm={() => goToNextStep("adhar-number")} />
        </div>
      )}
      {step === "adhar-number" && (
        <div ref={formRef}>
          <AdharNumber
            setAdharNumber={() => goToNextStep("adhar-otp")}
            setSendOtpFunction={setSendOtpFunction}
            setAdharNumbers={setAdharNumbers}
          />
        </div>
      )}
      {step === "adhar-otp" && (
        <div ref={formRef}>
          <AdhaOtp
            setAdharOtp={() => goToNextStep("mobile-verify-otp")}
            sendOtpFunction={sendOtpFunction}
          />
        </div>
      )}
      {step === "mobile-verify-otp" && (
        <div ref={formRef}>
          <MobileVerifyOtp
            setMobileverifyOtp={() => goToNextStep("aadhar-card")}
          />
        </div>
      )}
      {step === "aadhar-card" && (
        <div ref={formRef}>
          <AadharCard setAadharcart={() => goToNextStep("abha-address")} />
        </div>
      )}
      {step === "abha-address" && (
        <div ref={formRef}>
          <AbhaAddress setAdhaaddress={() => goToNextStep("done")} />
        </div>
      )}
      {step === "done" && (
        <div ref={formRef}>
          <AbhaCard setIsVerifiedMobile={() => goToNextStep("mobile-verify")} />
        </div> */}
      {/* )} */}

      {/* Stats Section */}
      <div className="banner-third-bg">
        <section className="container">
          {/* <div className="stats-section"> */}
          <div className="col-md-12">
            <div className="row">
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item1">
                  <b>
                    <CountUp end={700} duration={5} separator="," />
                    M+
                  </b>
                  <p>Ayushman Bharat Health Accounts (ABHA)</p>
                </div>
              </div>
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item2">
                  <b>
                    <CountUp end={600} duration={5} separator="," />
                    M+
                  </b>
                  <p>Health Records Linked</p>
                </div>
              </div>
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item3">
                  <b>
                    <CountUp end={400} duration={5} separator="," />
                    K+
                  </b>
                  <p>Verified Facilities on HFR</p>
                </div>
              </div>
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item4">
                  <b>
                    <CountUp end={600} duration={5} separator="," />
                    K+
                  </b>
                  <p>Verified Healthcare Professionals</p>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </section>
      </div>

      {/* Info and Benefits Section */}
      <section className="banner-forth-bg abha-info-section">
        <div className="bg-color">
          <div className="row">
            <div className="col-ms-1 col-lg-1"></div>
            <div className="col-ms-5 col-lg-5">
              {/* <button onClick={goToPreviousStep}>Go Back</button> */}
              {/* <button onClick={handleBack}>⬅️ Back</button> */}
              <div className="header-logos">
                <p>APPROVED BY NHA</p>
                <img src={about} alt="NHA Logo" className="nha-logo" />
                <img
                  src={lab}
                  alt="Pathkind Approved"
                  className="approved-logo approved-logo-nha"
                />
              </div>
              <div className="pathkind-lab">
                <h3>Create Pathkind Lab (Health ID)</h3>
              </div>
              <p className="abha-description">
                Be part of Ayushman Bharat Digital Mission (ABDM) and start your
                <br /> digital health journey
              </p>
              <button className="lik-abha-button" onClick={handleClick}>
                Create/Link Abha
              </button>
              <div className="app-links">
                <a
                  href="https://apps.apple.com/in/app/pathkind-labs/id6472930066"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={appstore} alt="App Store" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.pathkind.app"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={googleplay} alt="Google Play" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="abha-steps-section">
        <div className="container">
          <div className="heading-section">
            <h2>Benefits of ABHA HEALTH card</h2>
            <p>
              Creating ABHA card is the first step towards making digital health
              records safer and more
              <br /> efficient for you and your family.
            </p>
          </div>

          <div className="row">
            {[
              benefits,
              benefits2,
              benefits3,
              benefits4,
              benefits5,
              benefits6
            ].map((img, index) => (
              <div key={index} className="col-ms-6 col-lg-4">
                <div className="card-item">
                  <div className="benefit-item">
                    <div className="benefit-icons">
                      <img
                        src={img}
                        alt={`Benefit ${index + 1}`}
                        className="benefit-icon"
                      />
                      <h4>
                        {
                          [
                            "Digital Health Records",
                            "Personal Health Records (PHR)",
                            "Consent Based Access",
                            "Secure and Private",
                            "Voluntary Opt-In",
                            "Access to Doctors Digitally"
                          ][index]
                        }
                      </h4>
                    </div>
                  </div>
                  <p>
                    {
                      [
                        "All your health information at your fingertips.",
                        "Connect and integrate your individual health records using ABHA to build a comprehensive health history over time.",
                        "Your health data will only be accessed with your clear and informed consent.",
                        "Designed with robust security and encryption mechanisms, and no information is shared without your permission.",
                        "It is not mandatory to carry the ABHA Address card. If you wish to opt-out and request to erase your data at any time, you may do so",
                        "By registering for an ABHA Address, you will have access to doctors online securely and safely."
                      ][index]
                    }
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default CreatAbha;
